/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect, useState } from "react";
import LoginPageMeta from "./LoginPageMeta";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import Container from "@/src/components/Container/Container";
import AuthAction from "@/src/components/Auth/AuthAction";
import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import { AuthActionType } from "@/src/types/AuthActionType";
import loginPageStyle from "@/src/containers/Pages/Generic/LoginPage/loginPageStyle";
import { translate } from "@/src/services/translations/translations";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { useLocation, useNavigate } from "react-router";

export default function LoginPage() {
  const [authActionType, setAuthActionType] = useState<AuthActionType>("login");
  const { isLoggedIn } = useCustomer();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const { from } = location.state || { from: { pathname: "/servicewelt" } };
      navigate(from.pathname);
    }
  }, [isLoggedIn]);

  return (
    <LayoutPublicRoutes>
      <LoginPageMeta />
      <Container variant={"xs"} sx={loginPageStyle.container}>
        <Card sx={loginPageStyle.card}>
          <Typography align={"center"} component={"h1"} variant={"h5"}>
            {translate("auth." + authActionType, {})}
          </Typography>
          <Box sx={{ paddingTop: "1.5rem" }}>
            <AuthAction actionType={authActionType} onActionTypeChange={setAuthActionType} />
          </Box>
        </Card>
      </Container>
    </LayoutPublicRoutes>
  );
}
